export function buildVideoUrl(video) {
    if (video.service === "youtube") {
        return new URL("https://www.youtube.com/embed/".concat(video.id));
    }
    if (video.service === "vimeo") {
        return new URL("https://player.vimeo.com/video/".concat(video.id));
    }
    return null;
}

//# sourceMappingURL=buildVideoUrl.js.map